<template>
    <div class="scoreReportDialog" v-loading="loading">
        <el-dialog width="700"  :close-on-click-modal="false" :visible.sync="dialogVisible">
          <div slot="title">
            <span>{{myTitle}}</span>
            <span style="font-size: 12px;margin-left: 12px;">(总分
                <span style="color: red">{{totalScore}}</span>
              )</span>
          </div>
            <el-row>
                <el-col :span="24" class="head1">
                    1、选择统计指标：
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6" class="head2">
                    成绩分档按人数：
                </el-col>
                <el-col :span="8" class="head2">
                    <el-button type="text" @click="addScoreRange()">添加</el-button>
                    <el-button type="text" @click="defaultScoreRange()">恢复默认</el-button>
                </el-col>
            </el-row>
            <el-row class="my-row" v-for="(item, idx) in scoreRange">
                <el-col :span="4" >
                    <el-input size="mini" v-model="item.name"></el-input>
                </el-col>
                <el-col :span="3" style="text-align: center">
                    大于等于
                </el-col>
                <el-col :span="5" >
                    <el-input-number size="mini" :min="0" v-model="item.from"></el-input-number>
                </el-col>
                <el-col :span="2" style="text-align: center">
                    小于
                </el-col>
                <el-col :span="5" >
                    <el-input-number size="mini" :min="0" v-model="item.to"></el-input-number>
                </el-col>
                <el-col :span="3" >
                    <el-button type="text" @click="deleteScoreRange(idx)">删除</el-button>
                </el-col>
            </el-row>

          <el-row>
            <el-col :span="16" class="head1" style="margin-text-outline: 20px;">
              2、选择教学班统计范围
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="head3">
              <el-checkbox-group v-model="checkedTeachingArr4" >
                <el-checkbox v-for="item in arr4" :key="item.name" :label="item.name">{{item.name}}</el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-row>
            <el-row>
                <el-col :span="16" class="head1" style="margin-top: 20px;">
                    3、选择行政班统计范围：
                </el-col>
                <el-col :span="8" class="head3">
                    <el-button type="text" @click="setChecked3(true)">全选</el-button>
                    <el-button type="text" @click="setChecked3(false)">不选</el-button>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24" class="head3">

                  <el-checkbox-group v-model="checkedArr3">
                    <span style="margin-right: 20px;" v-for="(item, index) in arr3" :key="index">
                      <el-checkbox
                          v-for="(subItem, subIndex) in item.items"
                          :key="subIndex"
                          :label="subItem"
                          :disabled="uneditableItems.includes(subItem)"
                      >
                    </el-checkbox>
                    </span>
                  </el-checkbox-group>
                </el-col>
            </el-row>
          <el-row>
            <el-col :span="24" class="head1">
              4、大题统计： <el-button type="text" @click="addZgRange">添加</el-button>
            </el-col>
          </el-row>
          <el-row class="my-row" v-for="(item, idx) in zgRange">
            <el-col :span="3" >
              第{{idx+1}}大题
            </el-col>
            <el-col :span="5" style="text-align: center">
              <el-input size="mini" v-model="item.name"></el-input>
            </el-col>
            <el-col :span="4" >
              <el-input-number size="mini" :min="0" v-model="item.from"></el-input-number>
            </el-col>
            <el-col :span="2" style="text-align: center">
              至
            </el-col>
            <el-col :span="4" >
              <el-input-number size="mini" :min="0" v-model="item.to"></el-input-number>
            </el-col>
            <el-col :span="4" :offset="2">
              <el-button type="text" @click="deleteZgRange(idx)">删除</el-button>
            </el-col>
          </el-row>
            <el-row>
                <el-col :span="24" class="head-warning">
                    注意：分数段为百分比； 缺考、未扫描和被删除的学生均不统计在内
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
              <el-button type="primary" :loading="loading" :disabled="jsonData==null" @click="submitForm">生成并下载</el-button>

            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {mapGetters, mapState} from "vuex";
    import * as simpleApi from "request/simple";
    import XEUtils from 'xe-utils'
    import * as mUtils from '@/utils/mUtils'
    import axios from "axios";
    import XLSX from "xlsx";
    import dayjs from 'dayjs'

    export default {
        name: 'scoreReportDialog',
        data(){
            return {
                formLabelWidth: '120px', 
                myTitle: null, 
                myExamId: null,
                totalScore: 0,
                dialogVisible:false, loading: false,
                radioScore: '1', jsonData: null, teachingList: null,
                checkedArr2: [],checkedArr3: [],checkedTeachingArr4:[],
                uneditableItems:[],
                arr1: ['总人数', '实考人数', '缺考人数', '平均分', '最高分', '最低分'],
                arr3: [],
                arr4: [], // 教学班
                scoreRange: [], zgRange: [],
                scoreLevels: {score90: {name: '优秀', from: 90, to: 100}, score80: {name: '良好', from: 80, to: 90},
                    score70: {name: '中等', from: 70, to: 80},
                    score60: {name: '及格', from: 60, to: 70}, score0: {name: '不及格', from: 0, to: 60},},
                    

            }
        },
        components:{
        },
        computed:{
            ...mapState({
                userInfo: state => state.user.userInfo,
            }),
        },
      	mounted() {

	    },
        props: {
            info: {
                type: Object
            }
        },
        watch: {
          /** 暂弃 教学班和行政班暂时不做关联
          checkedTeachingArr4(newVal, oldVal) {
            console.log(newVal)
            // this.checkedarr2 = [];
            newVal.forEach(val => {
              console.log(val)
              console.log(this.arr3)
              let category = this.arr3.find(cat => cat.name === val);
              if (category) {
                // Add new items
                category.items.forEach(item => {
                  if (this.checkedArr3.includes(item)) {
                    this.checkedArr3 = this.checkedArr3.filter(i => i !== item);
                  }
                  this.checkedArr3.push(item);
                  // 将新添加的项标记为不可编辑
                  this.uneditableItems.push(item);
                  console.log(item+"================")
                });
              }
            });

            // Remove unselected items
            oldVal.forEach(val => {
              if (!newVal.includes(val)) {
                let category = this.arr3.find(cat => cat.name === val);
                if (category) {
                  this.checkedArr3 = this.checkedArr3.filter(item => !category.items.includes(item));
                  // 将取消选中的项从不可编辑的项中移除
                  this.uneditableItems = this.uneditableItems.filter(item => !category.items.includes(item));
                }
              }
            });
          },
           */
            info: {
                deep: true, immediate:true,
                handler(n, o){
                    console.log("report", n)
                    if(n){
                        this.myTitle = n.exam_name;
                        this.myExamId = n.exam_id;
                      this.totalScore = n.topic_score
                        this.defaultScoreRange();
                        let analyse_oss_name = window.g.OSS_HOST + n.analyse_oss_name;
                        this.loadExamAnalyse(analyse_oss_name);
                    }
                }
            },
        },
        methods: {
            showDialog(){
                this.dialogVisible = true;
            },
            hideDialog(){
                this.dialogVisible = false;
            },
            cancel(){
                this.dialogVisible = false;
                this.$emit('cancel');
            },

            setChecked3(selected){
                if(selected){
                  // 每个数据items遍历出来
                  this.checkedArr3 = this.arr3['其他班'].items.reduce((acc, cur) => {
                    return acc.concat(cur.slice());
                  }, []);
                }else{
                    this.checkedArr3 = [];
                }
            },
            addScoreRange(){
                this.scoreRange.push({name: "分数档"+this.scoreRange.length, from: 0, to: 0});
            },
            deleteScoreRange(idx){
                this.scoreRange.splice(idx, 1);
            },
            defaultScoreRange(){
                this.scoreRange = [{name: "优秀", from: 90, to: 100}, {name: "及格", from: 60, to: 100},
                    {name: "不及格", from: 0, to: 60}];
            },
            addZgRange(){
                this.zgRange.push({name: "", from: 1, to: 1})
            },
            deleteZgRange(idx){
              this.zgRange.splice(idx, 1);
            },
            loadTeachingClass(){
              let param = { controllerName: 'akExamTeaching', methodName: '/teachingList', param: { exam_id: this.examId }};
              let that = this;
              simpleApi.post(param).then(({ result: { code, data}, sysCode}) => {
                if (code == 0) {
                  console.log("loadTeachingClass", data);
                  this.teachingList = data;
                  if (data) {
                    for (let i = 0; i < data.length; i++) {
                      let d = data[i];
                      that.arr3.push(d.teaching_name);
                    }
                    that.checkedArr3 = that.arr3;
                  }
                }
              });
            },
            loadExamAnalyse(analyse_oss_name, callback){
              console.log("loadExamAnalyse", analyse_oss_name)
              this.loading = true;
                let that = this;
                axios.defaults.headers = {'Content-Type': 'application/json;charset=UTF-8'}
                axios({
                    method:'get',
                    url:analyse_oss_name + "?_=" + (new Date()).getTime(),
                }).then((res)=>{
                    let data = res.data;
                    console.log(data);
                    that.arr3 = [];
                    if(!("hard_scores" in data)){
                      this.$message({ type: 'error', message: '数据缺失，请重跑成绩!'});
                      this.loading = false;
                      return ;
                    }
                  if ('teaching_hard_class' in data){
                    that.arr4 = data.teaching_hard_class.map(item => ({id: item.id, name: item.name}));
                  }
                  let teaching_hard_classes = data.teaching_hard_class
                  if (teaching_hard_classes===undefined){
                    teaching_hard_classes = []
                  }

                  if ("hard_avg_count" in data) {

                    let hard_avg_count = data['hard_avg_count'];
                    let result = {};
                    if (teaching_hard_classes.length === 0) {

                      result["其他班"] = {"items":hard_avg_count.names};
                      that.arr3 =result
                    } else {

                      that.arr3 = teaching_hard_classes.map(item => {
                        return {
                          "name": item.name,
                          "items": item.hard_class.map(hardClass => hardClass.name)
                        };
                      });

                      let otherNames = data.hard_avg_count.names.filter(name => {
                        return !that.arr3.some(item => {
                          return item.items.includes(name);
                        });
                      });
                      that.arr3.push({"name": "其他", "items": otherNames});
                      // [
                      //   {
                      //     "name": "2312",
                      //     "items":
                      //         [
                      //           "2312(2)",
                      //           "2312(1)",
                      //           "2312(3)"
                      //         ]
                      //   },
                      //   {
                      //     "name": "2313",
                      //     "items":
                      //         [
                      //           "2313(2)",
                      //           "2313(1)"
                      //         ]
                      //   },
                      //   {
                      //     "name": "其他",
                      //     "items":
                      //         [
                      //           "2308",
                      //           "2309",
                      //           "2310",
                      //           "2311",
                      //           "2314(1)",
                      //           "2314(2)",
                      //           "2315(1)",
                      //           "2315(2)",
                      //           "2316"
                      //         ]
                      //   }
                      // ]
                      that.checkedArr3 = hard_avg_count.names
                    }


                    //   let hardName = data.hard_avg_count.names;
                      //   let items=[]
                      //   for (let i=0; i<hardName.length; i++){
                      //       // that.arr3.push(hardName[i]);
                      //     items.push(hardName[i])
                      //   }
                      // that.arr3.push({name: '各班级', items: items})
                      // {name: '其他', items: ['a', 'b', 'c']}
                      //   that.checkedArr3 = that.arr3;
                    }


                    that.jsonData = data;
                    this.loading = false;
                    if(callback) callback();
                }).catch((error) => {
                  
                  console.log(error)
                  this.loading = false;
                });

            },
          loadStudents(examId, hardList, callback){
            let analyse_oss_name = window.g.OSS_HOST+"answer/analyse/"+examId+"/exam_student_"+examId+".json";
            let that = this;
            axios.defaults.headers = {'Content-Type': 'application/json;charset=UTF-8'}
            axios({
              method:'get',
              url:analyse_oss_name + "?_=" + (new Date()).getTime(),
            }).then((res)=>{
              let hdScores = [];
              let data = res.data;
              if(data){
                for (let i=0; i<hardList.length; i++){
                  let p = {hardName: hardList[i]};
                  let hardStudents = XEUtils.filter(data, item => item.hard_name == hardList[i]);
                  if(hardStudents && hardStudents.length > 0){
                    for (let j=0; j<that.zgRange.length; j++){
                      p["zg"+j] = {name: that.zgRange[j].name, from: that.zgRange[j].from, to: that.zgRange[j].to, us: 0, rs: 0, cou: hardStudents.length};
                    }
                    let scoreDict = {}
                    XEUtils.arrayEach(hardStudents, (item, key) => {
                      let tiList = item.ti_list
                      for (let j=0; j<that.zgRange.length; j++){
                        let rFrom = parseInt(that.zgRange[j].from), rTo = parseInt(that.zgRange[j].to), rName = that.zgRange[j].name;
                        if(!(rName in scoreDict)) scoreDict[rName] = {list: []}
                        let zgRangeScore = 0
                        XEUtils.arrayEach(tiList, (tiItem, tiKey) => {
                          if(tiItem.ix>=rFrom && tiItem.ix<=rTo){
                            p["zg"+j]["us"] = p["zg"+j]["us"] + parseFloat(tiItem.us); p["zg"+j]["rs"] = p["zg"+j]["rs"] + parseFloat(tiItem.rs);
                            zgRangeScore = zgRangeScore + parseFloat(tiItem.us)
                            // console.log("each", j, rName, tiItem.ix, tiItem.us);
                          }
                        });
                        scoreDict[rName].list.push(zgRangeScore) //增加大题统计区分度数据
                      }
                    });
                    for (let j=0; j<that.zgRange.length; j++){
                      let rName = that.zgRange[j].name;
                      // console.log("top", rName, scoreDict[rName].list)
                      p["top27_"+j] = this.get27Avg(scoreDict[rName].list, true)
                      p["low27_"+j] = this.get27Avg(scoreDict[rName].list, false)
                      p["rs_"+j] = p["zg"+j]["rs"]/p["zg"+j]["cou"]
                      p["discrimination_"+j] = (p["top27_"+j]-p["low27_"+j]) / p["rs_"+j]
                      p["hard_mode_"+j] = 1-(p["zg"+j]["us"]/p["zg"+j]["rs"])
                    }
                    console.log("hdScores", p);
                    hdScores.push(p);
                  }
                }
                //汇总的区分度
                let p = {hardName: 't汇总'}
                let allScoreList = []
                for (let i=0; i<hardList.length; i++){
                  p["hd_"+hardList[i]] = {"top27": 0, "low27": 0}
                  let hardStudents = XEUtils.filter(data, item => item.hard_name == hardList[i]);
                  let scoreList = []
                  XEUtils.arrayEach(hardStudents, (item, key) => {
                    let tiList = item.ti_list
                    let tiTotalScore = 0
                    let zgRangeScore = 0
                    for (let j=0; j<that.zgRange.length; j++){
                      let rFrom = parseInt(that.zgRange[j].from), rTo = parseInt(that.zgRange[j].to), rName = that.zgRange[j].name;
                      XEUtils.arrayEach(tiList, (tiItem, tiKey) => {
                        if(tiItem.ix>=rFrom && tiItem.ix<=rTo){
                          zgRangeScore = zgRangeScore + parseFloat(tiItem.us)
                          tiTotalScore = tiTotalScore + parseFloat(tiItem.us)
                        }
                      });
                    }
                    scoreList.push(zgRangeScore) //增加大题统计区分度数据
                    allScoreList.push(tiTotalScore)
                  });
                  console.log('hz', hardList[i], scoreList)
                  p["hd_"+hardList[i]].top27 = this.get27Avg(scoreList, true)
                  p["hd_"+hardList[i]].low27 = this.get27Avg(scoreList, false)
                }
                console.log("allScore", allScoreList)
                p["allzg"] = {"top27": this.get27Avg(allScoreList, true), "low27": this.get27Avg(allScoreList, false), "avg": XEUtils.mean(allScoreList)}
                for (let i=0; i<that.zgRange.length; i++){
                  let rFrom = parseInt(that.zgRange[i].from), rTo = parseInt(that.zgRange[i].to), rName = that.zgRange[i].name;
                  p["tzg_" +i] = {"top27": 0, "low27": 0}
                  let scoreList = []
                  XEUtils.arrayEach(data, (item, key) => {
                    let tiList = item.ti_list
                    let zgRangeScore = 0
                    XEUtils.arrayEach(tiList, (tiItem, tiKey) => {
                      if(tiItem.ix>=rFrom && tiItem.ix<=rTo){
                        zgRangeScore = zgRangeScore + parseFloat(tiItem.us)
                      }
                    });
                    scoreList.push(zgRangeScore)
                  });
                  p["tzg_" +i].top27 = this.get27Avg(scoreList, true)
                  p["tzg_" +i].low27 = this.get27Avg(scoreList, false)
                }
                hdScores.push(p);
              }
              if(callback) callback(hdScores);
            }).catch((error) => {
              console.log("error", error)
            });
          },
          get27Avg(scoreList, isTop){
            let sortList = XEUtils.sortBy(scoreList)
            if(isTop) sortList = XEUtils.sortBy(scoreList).reverse()
            let endIdx = parseInt(sortList.length * 0.27)+1
            let list27 = []
            for (let i=0; i<endIdx; i++) list27.push(sortList[i])
            // console.log("get27", isTop, endIdx, list27)
            return XEUtils.mean(list27)
          },
          submitForm(){
            // debugger
                if(this.checkedArr3.length == 0 && this.checkedTeachingArr4.length == 0){
                    this.$message({ type: 'error', message: '请选择统计范围!'});
                    return ;
                }
                if(this.zgRange.length > 0){
                  for (let i=0; i<this.zgRange.length; i++){
                    if(this.zgRange[i].name == '' || this.zgRange[i].from <1  || this.zgRange[i].to <1){
                      this.$message({ type: 'error', message: '请输入大类统计名称和设置题数范围!'});
                      return ;
                    }
                  }
                }
                if(this.jsonData && "hard_score_count" in this.jsonData){
                    let hsc = this.jsonData.hard_score_count;
                    let list = this.transferData(hsc);
                    this.outputXlsxFile(list);
                }else{
                    console.log("hard_score_count not found")
                    this.$message({ type: 'error', message: '暂无数据!'});
                    return ;
                }
            },

            transferData(hsc){

              let first = ['年段'];
              // real: 实考人数
              // total 总分
              // avg 平均分
              // level10: 优秀、良好、中等、及格、不及格
              // range: 分数段
              // min: 最低分
              // max: 最高分
              let sht = {real: [], total: [], avg: [], level10: [], range: [], min: [], max: []};
              for(let i=0; i<this.checkedArr3.length; i++){
                  let ck = this.checkedArr3[i];
                  if (this.uneditableItems.includes(ck)){
                    continue
                  }
                  first.push(ck);
                  let f = XEUtils.find(this.teachingList, item => item.teaching_name == ck);
                  this.getHardScoreData(sht, ck);
              }

              // // 计算教学班
              for(let i=0; i<this.checkedTeachingArr4.length; i++){
                let ck = this.checkedTeachingArr4[i];
                first.push(ck);
                this.getTeachingScoreData(sht,ck,i)
                console.log(sht)
              }
              
              first.push('合计')
              console.log("sht", sht)
              let list = [first];
              let skCount = this.sumAvgArray(sht.real, "sum")
              list.push([...["实考人数"], ...sht.real, ...[skCount]]);
              let scoreCount = this.sumAvgArray(sht.total, "sum")
              list.push([...["总分"], ...sht.total, ...[scoreCount]]);
              list.push([...["平均分"], ...sht.avg, ...[parseFloat(scoreCount/skCount).toFixed(2)]]);
              let ranList = []; 
              for (let j=0; j<this.scoreRange.length;j++){
                let sr = this.scoreRange[j];
                let ran1 = [], lv1 = [];
                let numList = []
                for (let i=0; i<sht.range.length; i++){
                  let r = sht.range[i];
                  let f = XEUtils.find(r, item => item.name == sr.name);
                  if(f){
                    ran1.push(f.count);
                    numList.push(f.count)
                    // console.log(f.name, f.lv, parseFloat(f.lv));
                    lv1.push((parseFloat(f.lv)*10000/100).toFixed(2)+'%');
                  }
                }
                
                  let ranCount = this.sumAvgArray(ran1, "sum");

                  ran1.push(ranCount);
                  numList.push(ranCount)

                  // 多次循环注入会导致排序混乱
                  // ran1.unshift(sr.name)
                  
                  let nameList = [sr.name]
                  let a = []
                  a = nameList.concat(numList)

                  lv1.push((parseFloat(ranCount/skCount)*10000/100).toFixed(2)+'%');
                  // console.log(sr.name, parseFloat(parseFloat(ranCount/skCount)*10000/100).toFixed(2))
                  lv1.unshift(sr.name+"率")
                // console.log("lv1", lv1)
                list.push(lv1);

                // ranList.push(ran1)
                ranList.push(a)

              }
              let level10 = [];
              for (let i=sht.level10[0].length-1; i>=0; i--){
                let l10 = sht.level10[0][i];
                level10.push([l10.from+"-"+l10.to]);
              }
              for (let i=0; i<sht.level10.length; i++){
                let l10s = sht.level10[i];
                for (let j=l10s.length-1; j>=0; j--){
                  let l10 = l10s[j];
                  let key = l10.from+"-"+l10.to;
                  let f = XEUtils.find(level10, item => item[0] == key);
                  if(f){
                    f.push(l10.count);
                  }
                }
              }
                for (let i=0; i<level10.length; i++){
                    let l10 = level10[i];
                    let myArr = l10.concat();
                    l10.push(this.sumAvgArray(myArr.splice(1), "sum"));
                }
                // console.log('ranList===>',ranList);
              list = [...list, ...ranList, ...level10];
              let maxs = [], maxNames = ['最高分姓名'];
              for(let i=0; i<sht.max.length; i++){
                let m = sht.max[i];
                maxs.push(m.score);
                maxNames.push(m.names.join(","));
              }
                let allMax = XEUtils.max(maxs);
                let allMaxName = "";
                for (let i=0; i<maxs.length;i++){
                    if(allMax == maxs[i]) allMaxName = allMaxName + maxNames[i+1];
                }
                maxNames.push(allMaxName);
                maxs.unshift('最高分');
                maxs.push(allMax);
              let mins = [], minNames = ['最低分姓名'];
              for(let i=0; i<sht.min.length; i++){
                let m = sht.min[i];
                mins.push(m.score);
                minNames.push(m.names.join(","));
              }
                let allMin = XEUtils.min(mins);
                let allMinName = "";
                for (let i=0; i<mins.length;i++){
                    if(allMin == mins[i]) allMinName = allMinName + minNames[i+1];
                }
                minNames.push(allMinName);
                mins.unshift('最低分')
                mins.push(allMin);
              list.push(maxs); list.push(maxNames); list.push(mins); list.push(minNames);
              console.log("list", list)
              return list;
            },
            sumAvgArray(list, actType){
              let copiedList = [...list];
              // if(actType == "sum") return XEUtils.sum(list);
              // if(actType == "mean") return XEUtils.mean(list).toFixed(2);
              if(actType == "sum") return XEUtils.sum(copiedList);
              if(actType == "mean") return XEUtils.mean(copiedList).toFixed(2);
              return 0;
            },
            // 插入sht信息
            getHardScoreData(sht, ck){
              let hardScores = this.jsonData.hard_scores;
              let fullScore = this.jsonData.full_score;

              let fi = XEUtils.findIndexOf(hardScores, item => item.hardName==ck);
              if(fi > -1){
                let h = hardScores[fi];
                sht.real.push(h.count);
                sht.total.push(h.totalScore);
                sht.avg.push( (h.totalScore/h.count).toFixed(2));
                sht.min.push(h.min);
                sht.max.push(h.max);
                sht.level10.push(h.step10);
                let ran = [];
                // scoreRange： 优秀，及格，不及格人数
                for (let j=0; j<this.scoreRange.length;j++){
                  let sr = this.scoreRange[j];
                  let mcount = 0;
                  let myTo = (sr.to==fullScore)?(sr.to+1):sr.to;
                  XEUtils.arrayEach(h.scores, (item, key) => {
                    if(item.score >= sr.from && item.score < myTo){
                      mcount = mcount + item.count;
                    }
                  })
                  ran.push({name: sr.name, count: mcount, lv: (mcount/h.count).toFixed(4)});
                }
                sht.range.push(ran);
              }

            },
            getTeachingScoreData(sht, ck, idx){
                if(!("teaching_scores" in this.jsonData)){
                    return ;
                }
              let hardScores = this.jsonData.teaching_scores;
              let fullScore = this.jsonData.full_score;

              let fi = XEUtils.findIndexOf(hardScores, item => item.teachingName==ck);
              if(fi > -1){
                let h = hardScores[fi];
                sht.real.push(h.count);
                sht.total.push(h.totalScore);
                sht.avg.push( (h.totalScore/h.count).toFixed(4));
                sht.min.push(h.min);
                sht.max.push(h.max);
                sht.level10.push(h.step10);
                let ran = [];
                for (let j=0; j<this.scoreRange.length;j++){
                  let sr = this.scoreRange[j];
                  let mcount = 0;
                  let myTo = (sr.to==fullScore)?(sr.to+1):sr.to;
                  XEUtils.arrayEach(h.scores, (item, key) => {
                    if(item.score >= sr.from && item.score < myTo){
                      mcount = mcount + item.count;
                    }
                  })
                  ran.push({name: sr.name, count: mcount, lv: (mcount/h.count).toFixed(4)});
                }
                sht.range.push(ran);
              }
            },
            outputXlsxFile(data) {
                let time_ = dayjs().format('YYYYMMDD_HHmm') 

                let fileName = this.myTitle + '(' + this.myExamId + ')-成绩报告_' + time_ +'.xlsx'

                console.log(data)
                let that = this;
                let sheetNames = ['成绩单'];
                let sheetsList = {};
                let wb = XLSX.utils.book_new();
                sheetsList['成绩单'] = XLSX.utils.aoa_to_sheet(data);
                // sheetsList['成绩单']["!cols"] = [{ wpx: 100 }, { wpx: 100 }, { wpx: 100 }, { wpx: 100 },{ wpx: 100 } ,{ wpx: 100 },{ wpx: 100 }];
                if(this.zgRange.length > 0){
                  this.zgTiAna(function (excelData){
                    console.log("excelData", excelData)
                    sheetNames = ['成绩单', '各班级成绩分析'];
                    sheetsList['各班级成绩分析'] = XLSX.utils.aoa_to_sheet(excelData);
                    wb["SheetNames"] = sheetNames;
                    wb["Sheets"] = sheetsList;
                    XLSX.writeFile(wb, fileName);
                    
                    // XLSX.writeFile(wb, that.myTitle + "_成绩报告.xlsx");
                  });
                }else{
                  console.log("sheetNames", sheetNames)
                  wb["SheetNames"] = sheetNames;
                  wb["Sheets"] = sheetsList;
                  XLSX.writeFile(wb, fileName);

                  // XLSX.writeFile(wb, this.myTitle + "_成绩报告.xlsx");
                }
            },
            zgTiAna(callback){
              let hardList = []
              for(let i=0; i<this.checkedArr3.length; i++){
                let ck = this.checkedArr3[i];
                let f = XEUtils.find(this.teachingList, item => item.teaching_name == ck);
                if(!f) hardList.push(ck);;
              }
              let that = this;
              this.loadStudents(this.info.exam_id, hardList, function (dataList){
                let excelData = that.translateTi(dataList)
                callback(excelData)
              });
            },
          translateTi(dataList){
            console.log("translateTi", dataList);
            let first = ['', ''], data = [], zgLen = this.zgRange.length;
            for (let i=0; i<(zgLen+1)*6; i++) {
              data.push([])
            }

            let hn = {};
            for (let i=0; i<zgLen; i++) {
              let z = this.zgRange[i]
              let t_1 = 0, t_2 = 0, t_3 = 0, t_4 = 0, t_5 = 0, t_6 = 0, t_cou = 0;
              let row = data[i*6], row2 = data[i*6+1], row3 = data[i*6+2], row4 = data[i*6+3], row5 = data[i*6+4], row6 = data[i*6+5];
              row.push(z.name); row.push('得分率');
              row2.push("");row2.push('失分率');
              row3.push("");row3.push('平均分');
              row4.push("");row4.push('满分');
              row5.push("");row5.push('难度');
              row6.push("");row6.push('区分度');
              console.log("zgRange", z, row, row2, row3, row4, row5, row6);
              let isIn = false;
              for (let j=0; j<dataList.length-1; j++){
                let d = dataList[j]
                let fstIn = XEUtils.find(first, item => item == d.hardName)
                if(!fstIn) {first.push(d.hardName); hn[d.hardName] = [0, 0, 0, 0, 0, 0]}
                if(("zg"+i) in d){
                  let defen = parseFloat(d[("zg"+i)].us/d[("zg"+i)].rs).toFixed(4)
                  row.push((defen*100).toFixed(2)+'%'); t_1 = t_1 + parseFloat(defen); hn[d.hardName][0] = hn[d.hardName][0] + parseFloat(defen);
                  row2.push(((1-defen)*100).toFixed(2)+'%'); t_2 = t_2 + (1-defen); hn[d.hardName][1] = hn[d.hardName][1] + (1-defen);
                  row3.push((d[("zg"+i)].us/d[("zg"+i)].cou).toFixed(2)); t_3 = t_3 + d[("zg"+i)].us/d[("zg"+i)].cou; hn[d.hardName][2] = hn[d.hardName][2] + d[("zg"+i)].us/d[("zg"+i)].cou;
                  row4.push((d[("rs_"+i)]).toFixed(0)); t_4 = t_4 + d[("rs_"+i)]; hn[d.hardName][3] = hn[d.hardName][3] + d[("rs_"+i)];
                  row5.push((d[("hard_mode_"+i)]).toFixed(4)); t_5 = t_5 + d[("hard_mode_"+i)]; hn[d.hardName][4] = hn[d.hardName][4] + d[("hard_mode_"+i)];
                  row6.push((d[("discrimination_"+i)]).toFixed(4)); t_6 = t_6 + d[("discrimination_"+i)]; hn[d.hardName][5] = hn[d.hardName][5] + d[("discrimination_"+i)];
                  t_cou = t_cou +1
                  isIn = true
                  continue;
                }
              }
              console.log("total", t_1, t_2, t_cou)
              row.push((t_1/t_cou*100).toFixed(2)+'%');
              row2.push(((t_2/t_cou)*100).toFixed(2)+'%');
              row3.push((t_3/t_cou).toFixed(2));
              row4.push((t_4/t_cou).toFixed(0));
              row5.push((t_5/t_cou).toFixed(4));
              let hzp = dataList[dataList.length-1]
              console.log("hzp", hzp)
              row6.push((hzp["tzg_" +i].top27 - hzp["tzg_" +i].low27)/(t_4/t_cou).toFixed(4));
            }
            let tr1 = data[zgLen*6], tr2 = data[zgLen*6+1], tr3 = data[zgLen*6+2], tr4 = data[zgLen*6+3], tr5 = data[zgLen*6+4], tr6 = data[zgLen*6+5];
            tr1.push('汇总'); tr1.push('得分率');
            tr2.push("");tr2.push('失分率');
            tr3.push("");tr3.push('平均分');
            tr4.push("");tr4.push('满分');
            tr5.push("");tr5.push('难度');
            tr6.push("");tr6.push('区分度');
            let t_1 = 0, t_2 = 0, t_3 = 0, t_4 = 0, t_5 = 0, t_6 = 0, t_cou = 0;
            for (let i=2; i<first.length; i++){
              let st = first[i]
              if(st in hn){
                tr1.push((hn[st][0]/zgLen*100).toFixed(2)+'%'); t_1 = t_1 + parseFloat(hn[st][0]/zgLen);
                tr2.push((hn[st][1]/zgLen*100).toFixed(2)+'%'); t_2 = t_2 + (hn[st][1]/zgLen);
                tr3.push((hn[st][2]).toFixed(2)); t_3 = t_3 + (hn[st][2]);
                tr4.push((hn[st][3]).toFixed(0)); t_4 = t_4 + (hn[st][3]);
                tr5.push((hn[st][4]/zgLen).toFixed(4)); t_5 = t_5 + (hn[st][4]/zgLen);
                let hzp = dataList[dataList.length-1]
                console.log("huizong", hzp, st, hzp["hd_"+st])
                tr6.push(((hzp["hd_"+st].top27 - hzp["hd_"+st].low27 ) / hn[st][3]).toFixed(4)); t_6 = t_6 + (hn[st][5]/zgLen);
                t_cou = t_cou +1
              }
            }
            let hzp = dataList[dataList.length-1]
            console.log("allzg", hzp, hzp["allzg"])
            tr1.push((t_1/t_cou*100).toFixed(2)+'%');
            tr2.push(((t_2/t_cou)*100).toFixed(2)+'%');
            tr3.push((hzp["allzg"].avg).toFixed(2));
            tr4.push((t_4/t_cou).toFixed(0));
            tr5.push((1-hzp["allzg"].avg/(t_4/t_cou)).toFixed(4));

            tr6.push(((hzp["allzg"].top27 - hzp["allzg"].low27 ) / (t_4/t_cou)).toFixed(4));
            first.push("汇总")
            return  [...[first], ...data]
          },

        },
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">

    .scoreReportDialog{
        text-align: left;
        float: left;
        .head1{
            font-weight: bold;
            font-size: 18px;
        }
        .head2{
            line-height: 40px;
            margin-top: 10px;
            margin-bottom: 10px;
            font-size: 16px;
        }
        .head3{
            margin-top: 10px;
            margin-bottom: 10px;
            font-size: 16px;
        }
        .head-warning {
            margin-top: 20px;
            color: red;
        }
      .my-row{
        padding: 4px 12px;
      }
    }


</style>


